var ua = navigator.userAgent.toLowerCase();
var isiOS = (ua.indexOf('iphone') > -1) || (ua.indexOf('ipad') > -1);
if(isiOS) {
  var viewport = document.querySelector('meta[name="viewport"]');
  if(viewport) {
    var viewportContent = viewport.getAttribute('content');
    viewport.setAttribute('content', viewportContent + ', user-scalable=no');
  }
}
$(window).on('load', function() {
  // ページ読み込み時
  $(window).trigger('scroll');
});

document.addEventListener('DOMContentLoaded', function() {
  // 英字タイトルをspanで分ける
  let separateElemList = document.querySelectorAll('.ttl02 .sub_ttl');
  let separateElemListType02 = document.querySelectorAll('.ttl03 .sub_ttl');
  let separateElemListTop = document.querySelectorAll('.under_ttl > span');
  let separateElemListNode = Array.prototype.slice.call(separateElemList,0);
  let separateElemListType02Node = Array.prototype.slice.call(separateElemListType02,0);
  let separateElemListTopNode = Array.prototype.slice.call(separateElemListTop,0);

  // セクションタイトル(ttl02)
  separateText(separateElemListNode);

  // セクションタイトル(ttl03)
  separateText(separateElemListType02Node);

  // 下層ページTOP部分タイトル
  separateText(separateElemListTopNode);

  // ブラウザバック時リロード
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      $('body').addClass('is_slide');
      window.location.reload();
    }
  });


  // スムーズスクロール実行(共通)
  let anchors = document.querySelectorAll('a[data-scroll-id]');
  let anchorsNode = Array.prototype.slice.call(anchors,0);
  anchorsNode.forEach(function(anchor) {
    anchor.addEventListener('click', function() {
      smoothScroll(this.dataset.scrollId);
    });
  });
});

//ポインター
// $(function(){
//   var
//   cursor = $(".cursor"),
//   follower = $(".follower"),
//   cWidth = 8, //カーソルの大きさ
//   fWidth = 20, //フォロワーの大きさ
//   delay = 7, //数字を大きくするとフォロワーがより遅れて来る
//   mouseX = 0, //マウスのX座標
//   mouseY = 0, //マウスのY座標
//   posX = 0, //フォロワーのX座標
//   posY = 0; //フォロワーのX座標

//   //カーソルの遅延アニメーション
//   TweenMax.to({}, .001, {
//     repeat: -1,
//     onRepeat: function() {
//       posX += (mouseX - posX) / delay;
//       posY += (mouseY - posY) / delay;
      
//       TweenMax.set(follower, {
//           css: {    
//             left: posX - (fWidth / 2),
//             top: posY - (fWidth / 2)
//           }
//       });
      
//       TweenMax.set(cursor, {
//           css: {    
//             left: mouseX - (cWidth / 2),
//             top: mouseY - (cWidth / 2)
//           }
//       });
//     }
//   });

//   //マウス座標を取得
//   $(document).on("mousemove", function(e) {
//       mouseX = e.pageX;
//       mouseY = e.pageY;
//   });

//   $("a,input,label,button,select").on({
//     "mouseenter": function() {
//       cursor.addClass("is-active");
//       follower.addClass("is-active");
//     },
//     "mouseleave": function() {
//       cursor.removeClass("is-active");
//       follower.removeClass("is-active");
//     }
//   });
//   $("iframe").on({
//     "mouseenter": function() {
//       cursor.hide();
//       follower.hide();
//     },
//     "mouseleave": function() {
//       cursor.show();
//       follower.show();
//     }
//   });

//   if (navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0) {
//     cursor.hide();
//     follower.hide();
//   }
//   if (navigator.userAgent.indexOf('iPad') > 0 || navigator.userAgent.indexOf('Android') > 0) {
//     cursor.hide();
//     follower.hide();
//   }
// });


//ローディングアニメーション：画面が読み込まれた時、is_slideを外し、アニメーションさせる
$(window).on('load', function(){
  $('body').removeClass('is_slide');
});

//可視範囲に現れたらclass付与
$(window).on('scroll', function (){
  var elemFade = $('.fade');
  var elemCover = $('.cover');
  var elemTitleIcon = $('.ttl02 .ttl_icon');
  var popAnimOn = $('.pop_on');
  var isViewed = 'viewed';
  var scrollPos = $(window).scrollTop();
  var wh = $(window).height();

  elemFade.each(function () {
    var elemOffset = $(this).offset().top;
    if(scrollPos > elemOffset - wh + (wh / 5) ){
      $(this).addClass(isViewed);
    }
  });
  elemCover.each(function () {
    var elemOffset = $(this).offset().top;
    if(scrollPos > elemOffset - wh + (wh / 3) ){
      $(this).addClass(isViewed);
    }
  });
  elemTitleIcon.each(function () {
    var elemOffset = $(this).offset().top;
    if(scrollPos > elemOffset - wh + (wh / 5) ){
      $(this).addClass(isViewed);
    }
  });
  popAnimOn.each(function () {
    var elemOffset = $(this).offset().top;
    if(scrollPos > elemOffset - wh + (wh / 8) ){
      $(this).addClass(isViewed);
    }
  });
});

$(function(){
  //ローディングアニメーション：アンカーリンク、別ウィンドウでページを開く、javascript:void(0)の場合は実行しない
  $('a:not([href^="#"]):not([href^="javascript:void(0)"]):not([target]):not([href^="mail"]):not([href^="tel"])').on('click', function(e){
    e.preventDefault();
    url = $(this).attr('href');
    if (url !== '') {
      $('body').addClass('is_slide_in');

      setTimeout(function () {
        window.location = url;
      }, 700);
    }
    return false;
  });

  //ヘッダーメニューホバー処理
  $(".h_nav li").each(function(){
    var className = $(this).attr("class");
    var hHeight = $(".h_wrap").outerHeight();
    $(this).hover(function() {
      $(this).find("a").addClass("active");
      $("#" + className).css("top", hHeight + "px");
    },
    function() {
      $(this).find("a").removeClass("active");
      $("#" + className).css("top", "-120%");
    });
  });
  $(".menu_toggle_inner").each(function(){
    var idName = $(this).attr("id");
    var hHeight = $(".h_wrap").outerHeight();
    $(this).hover(function() {
      $("." + idName).find("a").addClass("active");
      $(this).css("top", hHeight + "px");
    },
    function() {
      $("." + idName).find("a").removeClass("active");
      $(this).css("top", "-120%");
    });
  });

  //文字サイズ変更
  $(".font_size_blk a").each(function(){
    $(this).click(function(){
      if ($(this).hasClass("font_small")) {
        $("html").css("font-size","50%");
        $(".font_size_blk a").removeClass("active");
        $(this).addClass("active");
      } else if ($(this).hasClass("font_mid")) {
        $("html").css("font-size","62.5%");
        $(".font_size_blk a").removeClass("active");
        $(this).addClass("active");
      } else if ($(this).hasClass("font_large")) {
        $("html").css("font-size","70%");
        $(".font_size_blk a").removeClass("active");
        $(this).addClass("active");
      }
    });
  });

  //ハンバーガーメニュー処理
  $(".hum_trigger").click(function(){
    $(".hum_menu").addClass("active");
    $("html").css("overflow", "hidden");
  });
  $(".hum_bg, .trigger_close, .hum_toggle_link, .hum_toggle_menu a, .hum_btn_close").click(function(){
    $(".hum_menu").removeClass("active");
    $("html").css("overflow", "visible");
  });

  $(".hum_toggle_trigger").each(function(){
    $(this).click(function(){
      $(this).next(".hum_toggle_menu").slideToggle(300);
      $(this).toggleClass("open");
    });
  });
});

// イージング設定
const ScrollEase = {
  easeInOut: function (t) {
    var ccc = 0;
    if (t < .5) {
        ccc = 4 * t * t * t;
    } else {
        ccc = (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    }
    return ccc;
  }
}

function smoothScroll(scrollID) {
  let duration = 470;
  // スクロール先座標を取得
  let targetOffset = window.pageYOffset + document.getElementById(scrollID).getBoundingClientRect().top;
  // 現在のスクロール位置を取得
  let currentPostion = document.documentElement.scrollTop || document.body.scrollTop;
  // クリック時点での時間を取得
  let startTime = performance.now();
  // アニメーションを定義
  var smoothScroll = function(nowTime) {
    // 経過時間
    let elapsedTime = nowTime - startTime;
    let elapsedNormalize = elapsedTime / duration;
    // 経過時間がdurationに達していない場合は実行
    if(elapsedNormalize < 1) {
      window.scrollTo(0, currentPostion + ((targetOffset - currentPostion) * ScrollEase.easeInOut(elapsedNormalize)));
      // アニメーションを継続
      requestAnimationFrame(smoothScroll);
      // duration に経過時間が達したら、アニメーションを終了
    } else {
      window.scrollTo(0, targetOffset);
    }
  };
  requestAnimationFrame(smoothScroll);
}

function separateText(targetNodeList) {
  let resultText = [];
  targetNodeList.forEach(function(elem) {
    let separateText = elem.textContent;
    resultText = separateText.split('').map(function(value) {
      let span = document.createElement('span');
      if(value != ' ') {
        span.classList.add('fade');
      }
      span.style.display = 'inline-block';
      span.textContent = value;
      return span;
    });
    elem.textContent = '';
    resultText.forEach(function(span) {
      elem.appendChild(span);
    });
  });
}
